import BulgurProduct from 'models/BulgurProduct'

export const packagingInitialState = {
  category: BulgurProduct.category,
  subCategory: BulgurProduct.subCategory,
  GrainSize: '16 ounces only',
  Organic: false,
}
